var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28.726,
    height: 16.179,
    viewBox: "0 0 28.726 16.179",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-en"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.726,
    height: 16.179,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-en)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.726,
    height: 1.245,
    transform: "translate(0 14.934)",
    fill: "#ca2027"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.726,
    height: 1.245,
    transform: "translate(0 13.69)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.726,
    height: 1.244,
    transform: "translate(0 12.446)",
    fill: "#ca2027"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.726,
    height: 1.245,
    transform: "translate(0 11.201)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.726,
    height: 1.245,
    transform: "translate(0 9.956)",
    fill: "#ca2027"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.726,
    height: 1.244,
    transform: "translate(0 8.712)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.726,
    height: 1.245,
    transform: "translate(0 7.468)",
    fill: "#ca2027"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.726,
    height: 1.244,
    transform: "translate(0 6.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.726,
    height: 1.245,
    transform: "translate(0 4.978)",
    fill: "#ca2027"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.726,
    height: 1.245,
    transform: "translate(0 3.733)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.726,
    height: 1.245,
    transform: "translate(0 2.489)",
    fill: "#ca2027"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.726,
    height: 1.244,
    transform: "translate(0 1.245)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.726,
    height: 1.245,
    fill: "#ca2027"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.115,
    height: 8.712,
    fill: "#2b3561"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.4-233.979l.111.33h.359l-.29.2.111.329-.29-.2-.291.2.111-.329-.29-.2h.358Z",
    transform: "translate(-517.22 234.939)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11947",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11947",
    d: "M518.4-226.4l.111.329h.359l-.29.2.111.33-.29-.2-.291.2.111-.33-.29-.2h.358Z",
    transform: "translate(-517.22 228.811)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11948",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11948",
    d: "M518.4-218.813l.111.329h.359l-.29.2.111.33-.29-.2-.291.2.111-.33-.29-.2h.358Z",
    transform: "translate(-517.22 222.681)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11949",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11949",
    d: "M518.4-211.231l.111.329h.359l-.29.2.111.328-.29-.2-.291.2.111-.328-.29-.2h.358Z",
    transform: "translate(-517.22 216.554)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11950",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11950",
    d: "M518.4-203.647l.111.329h.359l-.29.2.111.329-.29-.2-.291.2.111-.329-.29-.2h.358Z",
    transform: "translate(-517.22 210.425)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11951",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11951",
    d: "M523.684-229.982l.111.329h.358l-.29.2.111.329-.29-.2-.29.2.111-.329-.29-.2h.359Z",
    transform: "translate(-521.452 231.708)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11952",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11952",
    d: "M523.684-222.4l.111.328h.358l-.29.2.111.329-.29-.2-.29.2.111-.329-.29-.2h.359Z",
    transform: "translate(-521.452 225.579)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11953",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11953",
    d: "M523.684-214.821l.111.329h.358l-.29.2.111.329-.29-.2-.29.2.111-.329-.29-.2h.359Z",
    transform: "translate(-521.452 219.455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11954",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11954",
    d: "M523.684-207.238l.111.329h.358l-.29.2.111.328-.29-.2-.29.2.111-.328-.29-.2h.359Z",
    transform: "translate(-521.452 213.326)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11955",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11955",
    d: "M529.032-233.979l.111.33h.358l-.29.2.111.329-.29-.2-.29.2.111-.329-.29-.2h.358Z",
    transform: "translate(-525.739 234.939)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11956",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11956",
    d: "M529.032-226.4l.111.329h.358l-.29.2.111.33-.29-.2-.29.2.111-.33-.29-.2h.358Z",
    transform: "translate(-525.739 228.811)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11957",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11957",
    d: "M529.032-218.813l.111.329h.358l-.29.2.111.33-.29-.2-.29.2.111-.33-.29-.2h.358Z",
    transform: "translate(-525.739 222.681)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11958",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11958",
    d: "M529.032-211.231l.111.329h.358l-.29.2.111.328-.29-.2-.29.2.111-.328-.29-.2h.358Z",
    transform: "translate(-525.739 216.554)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11959",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11959",
    d: "M529.032-203.647l.111.329h.358l-.29.2.111.329-.29-.2-.29.2.111-.329-.29-.2h.358Z",
    transform: "translate(-525.739 210.425)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11960",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11960",
    d: "M534.312-229.982l.111.329h.359l-.29.2.11.329-.29-.2-.29.2.111-.329-.29-.2h.358Z",
    transform: "translate(-529.969 231.708)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11961",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11961",
    d: "M534.312-222.4l.111.328h.359l-.29.2.11.329-.29-.2-.29.2.111-.329-.29-.2h.358Z",
    transform: "translate(-529.969 225.579)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11962",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11962",
    d: "M534.312-214.821l.111.329h.359l-.29.2.11.329-.29-.2-.29.2.111-.329-.29-.2h.358Z",
    transform: "translate(-529.969 219.455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11963",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11963",
    d: "M534.312-207.238l.111.329h.359l-.29.2.11.328-.29-.2-.29.2.111-.328-.29-.2h.358Z",
    transform: "translate(-529.969 213.326)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11964",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11964",
    d: "M539.66-233.979l.111.33h.358l-.29.2.111.329-.29-.2-.29.2.111-.329-.29-.2h.358Z",
    transform: "translate(-534.255 234.939)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11965",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11965",
    d: "M539.66-226.4l.111.329h.358l-.29.2.111.33-.29-.2-.29.2.111-.33-.29-.2h.358Z",
    transform: "translate(-534.255 228.811)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11966",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11966",
    d: "M539.66-218.813l.111.329h.358l-.29.2.111.33-.29-.2-.29.2.111-.33-.29-.2h.358Z",
    transform: "translate(-534.255 222.681)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11967",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11967",
    d: "M539.66-211.231l.111.329h.358l-.29.2.111.328-.29-.2-.29.2.111-.328-.29-.2h.358Z",
    transform: "translate(-534.255 216.554)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11968",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11968",
    d: "M539.66-203.647l.111.329h.358l-.29.2.111.329-.29-.2-.29.2.111-.329-.29-.2h.358Z",
    transform: "translate(-534.255 210.425)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11969",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11969",
    d: "M544.939-229.982l.111.329h.358l-.29.2.111.329-.291-.2-.29.2.11-.329-.29-.2h.359Z",
    transform: "translate(-538.485 231.708)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11970",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11970",
    d: "M544.939-222.4l.111.328h.358l-.29.2.111.329-.291-.2-.29.2.11-.329-.29-.2h.359Z",
    transform: "translate(-538.485 225.579)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11971",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11971",
    d: "M544.939-214.821l.111.329h.358l-.29.2.111.329-.291-.2-.29.2.11-.329-.29-.2h.359Z",
    transform: "translate(-538.485 219.455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11972",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11972",
    d: "M544.939-207.238l.111.329h.358l-.29.2.111.328-.291-.2-.29.2.11-.328-.29-.2h.359Z",
    transform: "translate(-538.485 213.326)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11973",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11973",
    d: "M550.288-233.979l.111.33h.359l-.29.2.11.329-.29-.2-.29.2.111-.329-.29-.2h.359Z",
    transform: "translate(-542.771 234.939)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11974",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11974",
    d: "M550.288-226.4l.111.329h.359l-.29.2.11.33-.29-.2-.29.2.111-.33-.29-.2h.359Z",
    transform: "translate(-542.771 228.811)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11975",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11975",
    d: "M550.288-218.813l.111.329h.359l-.29.2.11.33-.29-.2-.29.2.111-.33-.29-.2h.359Z",
    transform: "translate(-542.771 222.681)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11976",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11976",
    d: "M550.288-211.231l.111.329h.359l-.29.2.11.328-.29-.2-.29.2.111-.328-.29-.2h.359Z",
    transform: "translate(-542.771 216.554)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11977",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11977",
    d: "M550.288-203.647l.111.329h.359l-.29.2.11.329-.29-.2-.29.2.111-.329-.29-.2h.359Z",
    transform: "translate(-542.771 210.425)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11978",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11978",
    d: "M555.569-229.982l.11.329h.359l-.29.2.111.329-.29-.2-.291.2.111-.329-.29-.2h.358Z",
    transform: "translate(-547.003 231.708)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11979",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11979",
    d: "M555.569-222.4l.11.328h.359l-.29.2.111.329-.29-.2-.291.2.111-.329-.29-.2h.358Z",
    transform: "translate(-547.003 225.579)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11980",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11980",
    d: "M555.569-214.821l.11.329h.359l-.29.2.111.329-.29-.2-.291.2.111-.329-.29-.2h.358Z",
    transform: "translate(-547.003 219.455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11981",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11981",
    d: "M555.569-207.238l.11.329h.359l-.29.2.111.328-.29-.2-.291.2.111-.328-.29-.2h.358Z",
    transform: "translate(-547.003 213.326)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11982",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11982",
    d: "M560.916-233.979l.111.33h.359l-.29.2.11.329-.289-.2-.29.2.11-.329-.29-.2h.359Z",
    transform: "translate(-551.288 234.939)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11983",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11983",
    d: "M560.916-226.4l.111.329h.359l-.29.2.11.33-.289-.2-.29.2.11-.33-.29-.2h.359Z",
    transform: "translate(-551.288 228.811)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11984",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11984",
    d: "M560.916-218.813l.111.329h.359l-.29.2.11.33-.289-.2-.29.2.11-.33-.29-.2h.359Z",
    transform: "translate(-551.288 222.681)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11985",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11985",
    d: "M560.916-211.231l.111.329h.359l-.29.2.11.328-.289-.2-.29.2.11-.328-.29-.2h.359Z",
    transform: "translate(-551.288 216.554)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11986",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11986",
    d: "M560.916-203.647l.111.329h.359l-.29.2.11.329-.289-.2-.29.2.11-.329-.29-.2h.359Z",
    transform: "translate(-551.288 210.425)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11987",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11987",
    d: "M566.2-229.982l.111.329h.358l-.29.2.111.329-.29-.2-.29.2.111-.329-.29-.2h.359Z",
    transform: "translate(-555.52 231.708)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11988",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11988",
    d: "M566.2-222.4l.111.328h.358l-.29.2.111.329-.29-.2-.29.2.111-.329-.29-.2h.359Z",
    transform: "translate(-555.52 225.579)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11989",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11989",
    d: "M566.2-214.821l.111.329h.358l-.29.2.111.329-.29-.2-.29.2.111-.329-.29-.2h.359Z",
    transform: "translate(-555.52 219.455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11990",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11990",
    d: "M566.2-207.238l.111.329h.358l-.29.2.111.328-.29-.2-.29.2.111-.328-.29-.2h.359Z",
    transform: "translate(-555.52 213.326)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11991",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11991",
    d: "M571.545-233.979l.111.33h.358l-.29.2.111.329-.29-.2-.29.2.111-.329-.29-.2h.359Z",
    transform: "translate(-559.806 234.939)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11992",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11992",
    d: "M571.545-226.4l.111.329h.358l-.29.2.111.33-.29-.2-.29.2.111-.33-.29-.2h.359Z",
    transform: "translate(-559.806 228.811)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11993",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11993",
    d: "M571.545-218.813l.111.329h.358l-.29.2.111.33-.29-.2-.29.2.111-.33-.29-.2h.359Z",
    transform: "translate(-559.806 222.681)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11994",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11994",
    d: "M571.545-211.231l.111.329h.358l-.29.2.111.328-.29-.2-.29.2.111-.328-.29-.2h.359Z",
    transform: "translate(-559.806 216.554)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11995",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 11995",
    d: "M571.545-203.647l.111.329h.358l-.29.2.111.329-.29-.2-.29.2.111-.329-.29-.2h.359Z",
    transform: "translate(-559.806 210.425)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.d9d89339e18e855b7197efd4833974aa.svg";
export { ForwardRef as ReactComponent };